const awsmobile = {
  "aws_appsync_region": "ap-southeast-2",
  "aws_appsync_authenticationType": "API_KEY",
  "aws_appsync_graphqlEndpoint": "https://wuh4llhsxngidp53hg4rhfadfi.appsync-api.ap-southeast-2.amazonaws.com/graphql",
  "aws_appsync_apiKey": "da2-jtxbd6evpvbedmmtlng4memjoi"
};

export default awsmobile;
